<template>
  <div class="container">
    <h1 class="page-title">CORE Loader - Service</h1>
    <div>
      <table class="data-table" id="mytable">
        <thead>
          <tr>
            <th>SN</th>
            <th>Category</th>
            <th>Product</th>
            <th>Price</th>
          </tr>
        </thead>
        <tbody :key="tablekey"></tbody>
      </table>
    </div>

    <button
      class="form-button"
      style="background-color: green"
      v-if="!uploadingContent"
      @click.prevent="storeMeeting"
    >
      Submit
    </button>
    <p v-if="uploadingContent">uploading <span class="loader"></span></p>
    <br /><br />

    <label>Upload CSV File</label><br />
    <input
      type="file"
      class="bg-red-800 p-2 w-full mt-2 text-gray-200 hover:bg-red-900 border rounded-md"
      @change="handleFileUpload"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import axios from "axios";
import $ from "jquery";
import "datatables.net";
import Swal from "sweetalert2";

const service = ref("");
const category = ref("");
const price = ref("");
const form = ref([]);
const updateMode = ref(false);
const id = ref(0);
const csvfile = ref();
const tablekey = ref(0);
const uploadingContent = ref(false);
const url = ref();

const handleFileUpload = async (event) => {
  const file = event.target.files[0];
  csvfile.value = file;
  const formdata = new FormData();
  formdata.append("template", csvfile.value);

  const { status, data } = await axios.post(
    `${url.value}/api/v1/core/upload-services`,
    formdata
  );

  if (status === 200) {
    data.data.forEach((element) => {
      const formData = {
        service: element["CATEGORY"],
        category: element["PRODUCT"],
        price: element["PRICE"],
      };

      localStorage.setItem("data", formData);

      form.value.push(formData);
    });

    datatable();
  }
};

// const submitForm = () => {
const datatable = () => {
  // Initialize DataTable with your data
  $("#mytable").DataTable({
    paging: true, // Enable pagination
    searching: true, // Enable search
    ordering: true, // Enable sorting
    data: form.value, // Use the data from your ref
    columns: [
      { data: null, render: (data, type, row, meta) => meta.row + 1 },
      { data: "service" },
      { data: "category" },
      { data: "price" },
    ],
    // Add more options here as needed
  });
};

const storeMeeting = async () => {
  uploadingContent.value = true;
  const { status } = await axios.post(
    `${url.value}/api/v1/core/save-services?param=service_category`,
    form.value
  );
  if (status === 200 || status === 201) {
    Swal.fire({
      title: "Success!",
      text: "Data Stored Successfully!",
      icon: "success",
      confirmButtonText: "Ok!",
    });
    uploadingContent.value = false;
  }
};

window.updateData = (index) => {
  updateMode.value = true;
  const data = form.value[index];
  id.value = index;
  service.value = data.service;
  category.value = data.category;
  price.value = data.price;
};

const settings = ref();
const getUrl = () => {
  const storedSettings = localStorage.getItem("settings");
  if (storedSettings) {
    settings.value = JSON.parse(storedSettings);
    url.value = settings.value.defaultStates[0].budget;
  }
};

onMounted(() => {
  getUrl();
});
</script>

<style>
/* Add your CSS styles in a separate stylesheet or <style> block */
.container {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
}

.page-title {
  font-size: 24px;
  margin-bottom: 20px;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid black;
}

.data-table th,
.data-table td {
  border: 1px solid black;
  padding: 10px;
  text-align: left;
}

.form-button {
  margin-top: 10px;
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
}

.form-fields {
  margin-top: 20px;
}

.input-field {
  width: 40%;
  padding: 5px;
  margin: 5px 0;
  border: 1px solid #ccc;
}

.loader {
  width: 10px;
  height: 10Zpx;
  border: 2px solid black;
  border-bottom-color: transparent;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
